import { useEffect, useState } from "react";
import { getDeferredPrompt, isIOS, isStandalone, subscribe } from "@/lib/pwa";

/**
 * Install state for the current device:
 * - installed: already running as an installed PWA (hide any install UI)
 * - canInstall: Android / desktop Chrome captured a prompt we can fire
 * - needsIosInstructions: iOS Safari, where install is manual (Share → Add)
 */
export function useInstallPrompt() {
  const [, rerender] = useState(0);
  useEffect(() => subscribe(() => rerender((n) => n + 1)), []);

  const installed = isStandalone();
  return {
    installed,
    canInstall: !installed && !!getDeferredPrompt(),
    needsIosInstructions: !installed && isIOS() && !getDeferredPrompt(),
  };
}
